// @ts-expect-error untyped
import MakeConnectedAPIDropdownProvider from 'customer-data-reference-ui-components/connector/MakeConnectedAPIDropdownProvider';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import { OWNER } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped
import OwnerPagedReferenceResolver from 'reference-resolvers/resolvers/OwnerPagedReferenceResolver';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { NO_OWNER } from '../../constants/viewFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTooltipMessage = value => {
  if (value === NO_OWNER) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.filters.assignedTo.tooltips.unassigned"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.filters.assignedTo.tooltips.ownedOnly"
  });
};

/*

Using this may cause visual issues where if the text is:
- on multiple lines, text below might not be visible
- too long on one line, the tooltip might be floating in areas not the UISelect

These are due to limitations with using virtualizedMenuRenderer and having
custom options making the renderer unable to correctly calculate the height
of the option

*/
export const getDropdownText = ({
  text,
  value
}, disabled) => {
  if (!disabled) {
    return text;
  } else {
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !disabled,
      title: getTooltipMessage(value),
      placement: "top right",
      children: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "danger"
        }), text]
      })
    });
  }
};
const OwnerSelect = MakeConnectedAPIDropdownProvider({
  referenceObjectType: OWNER,
  referenceResolver: OwnerPagedReferenceResolver
});
export default OwnerSelect;